const rules = {
  admin: [
    "basicMessages:create",
    "basicMessages:read",
    "contacts:create",
    "contacts:read",
    "contacts:update",
    "contacts:delete",
    "credentials:issue",
    "credentials:read",
    "credentials:reissue",
    "credentials:revoke",
    "demographics:create",
    "demographics:read",
    "demographics:update",
    "demographics:delete",
    "invitations:create",
    "invitations:accept",
    "invitations:delete",
    "organizations:create",
    "organizations:read",
    "organizations:update",
    "roles:read",
    "settings:read",
    "settings:update",
    "users:create",
    "users:read",
    "users:update",
    "users:delete",
    "users:updatePassword",
    "users:updateRoles",
  ],
  "demo user": [
    "basicMessages:create",
    "basicMessages:read",
    "credentials:issue",
    "credentials:read",
    "credentials:reissue",
  ],
};

module.exports = rules;
